import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

export const fetchSubscriptions = async ({
   page = 1,
   limit = 10,
   filter = null,
   search = null,
 }) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    if (filter?.status) {
      query += `&status=${encodeURIComponent(filter.status)}`;
    }

    if (search) {
      query += `&search=${encodeURIComponent(search)}`;
    }

    const response = await authClient.get(`/subscriptions${query}`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
        error,
        'Došlo je do greške pri dobavljanju pretplata.'
    );
    return { data: null, success: false, message };
  }
};

export const fetchSubscriptionById = async (id) => {
  try {
    const response = await authClient.get(`/subscriptions/${id}`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
        error,
        'Došlo je do greške pri dobavljanju pretplate.'
    );
    return { data: null, success: false, message };
  }
};

export const cancelSubscriptionForUser = async (userId) => {
  try {
    const response = await authClient.delete(`/subscriptions/admin/${userId}`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri otkazivanju pretplate.'
    );
    return { data: null, success: false, message };
  }
};

export const fetchPackageSubscriptions = async ({
   page = 1,
   limit = 10,
   status = null,
   search = null,
 }) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    if (status) {
      query += `&status=${encodeURIComponent(status)}`;
    }

    if (search) {
      query += `&search=${encodeURIComponent(search)}`;
    }

    const response = await authClient.get(`/package-subscriptions${query}`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
        error,
        'Došlo je do greške pri dobavljanju pretplata na pakete.'
    );
    return { data: null, success: false, message };
  }
};

